export default __webpack_public_path__ + "static/media/spint.1da2a199.svg";